import axios from "axios";
import store from '../index';

export default {
  namespaced: true,
  state: {
    // Chatter 관련 데이터
    total: 0,
    files: [],
    /**
     * occupied
     *
     * Chatter Status Board가 이미 Chatter List를 사용하고 있음을 나타내는 플래그.
     * Chatter List 리로드 시 filter를 무시하도록 구현되어 있음.
     * TODO 추후 기능 개선 필요
     * @author Jiwon Yoon 2023-08-17
     */
    occupied: false,
    filterOccupied : false,
    filter: {
      projectId: "",
      status: "",
      keyword: "",
      page: 1,
      pageSize: 10,
    },
    //Chatter 페이지에 있는 toggle 정보 저장(create 되어도 상태 유지하기 위함)
    pageInfo:{
      toggle:{
        //Filter의 Search Detail
        filterSearchDetail:false,
        filterClosedProjects:false,
        filterInfo:false
      }
    },
  },
  getters: {
    files(state) {
      return state.files;
    },
    total(state) {
      return state.total;
    },
    occupied(state) {
      return state.occupied;
    },
    filterOccupied(state){
      return state.filterOccupied;
    },
    filter(state) {
      return state.filter;
    },
    options(state) {
      return state.options;
    },
    statusOptions(state) {
      return state.options.statusOptions;
    },
    projectOptions(state) {
      return state.options.projectOptions;
    },
    priorityOptions(state) {
      return state.options.priorityOptions;
    },
    importanceOptions(state) {
      return state.options.importanceOptions;
    },
    businessCategoryOptions(state) {
      return state.options.businessCategoryOptions;
    },
    systemOptions(state) {
      return state.options.systemOptions;
    },
    resultOptions(state) {
      return state.options.resultOptions;
    },
    levelOptions(state) {
      return state.options.levelOptions;
    },
    typeOptions(state) {
      return state.options.typeOptions;
    },
    fieldOptions(state) {
      return state.options.fieldOptions;
    },
    operatorOptions(state) {
      return state.options.operatorOptions;
    },
    valueOptions(state) {
      return state.options.valueOptions;
    },
    jobOptions(state) {
      return state.options.jobOptions;
    },
    projectStatusOptions(state) {
      return state.options.projectStatusOptions;
    },
    getProjectList(state) {
      return state.projectList;
    },
    getNotifications(state) {
      return state.notifications;
    },
    getToggle(state){
      return state.pageInfo.toggle;
    },
  },
  actions: {

    // 23-10-11 컴포넌트 로드 시 매번 수행하던 아래 로직 Top Bar에서 단 한번만 수행하도록 변경 retrieveAssigneeOptions
    // async retrieveProjectOptions({commit}) {
    //   let response = await axios.post(
    //     "chatter/retrieveProjectList",
    //     {},
    //     {headers: {Authorization: accessToken()}}
    //   );
    //   commit("setProjectOptions", response.data);
    // },
    async retrieveAssigneeOptions({commit}) {
      let response = await axios.get('chatter/retrieveChattererList', {
        headers: {Authorization: accessToken()}
      })
      commit("setAssigneeOptions", response.data);
    },
    async retrieveAllProjectInfo(context) {
      let response = await axios.get('chatter/retrieveAllProjectInfo', {
        headers: {Authorization: accessToken()}
      });
      context.commit('setAllProjectInfo', response.data.projectInfo);
      context.commit('setAllProjectRoles', response.data.roles);
      
      // Project Options 세팅
      context.commit('setProjectOptions', response.data.projectInfo);
    },
    synchronizeChatData(context, chatId) {

      // console.log(chatId);
      let params = Object.assign({}, context.state.filter);
      params['chatIdList'] = [chatId];

      // console.log(params);

      try {
        axios.post('chatter/retrieveChatterList',
          params,
        {
          headers:{Authorization: accessToken()}
        }).then(response => {
          if(response.data.list.length === 1) {
            // 생성, 수정 된 Chatter가 Filter의 조건에 맞을 때
            // console.log('필터 조건 충족');
            context.commit('setChat', response.data.list[0]);
          } else if (response.data.list.length < 1) {
            // 생성, 수정 된 Chatter가 Filter의 조건에 맞지 않을 때
            // console.log('필터링');
            context.commit('removeChat', chatId);
          }
        })
      } catch (e) {
        console.log(e);
      }
    }
  },
  mutations: {
    setChats(state, chats) {
      state.chats = chats;
    },
    setChat(state, newChat) {
      let idx = state.chats.findIndex(chat => chat.chatId === newChat.chatId);

      // 새로운 chat일 때
      if(idx === -1) {
        state.chats.unshift(newChat);
        state.total += 1;
      } else { // 수정된 chat일 때
        state.chats[idx] = newChat;
      }
    },
    /** 사용자가 Chatter를 읽었을 때 Vuex에 있는 Chatter라면 상태 변화
     * (updated, unread)
     * @param {*} state 
     * @param {*} chatId 
     */
    readChat(state, chatId) {
      let readChat = state.chats.find(chat => chat.chatId === chatId);
      const currentUser = store.getters['auth/currentUser'];
      
      // vuex에 없는 Chatter면 리턴
      if(readChat === undefined) return;

      readChat.updated = false;
      // Assignee와 Caller가 같을 때 읽음 처리
      if(readChat.assignee === currentUser.caller) {
        readChat.unread = true;
      }
    },
    removeChat(state, chatId) {
      let idx = state.chats.findIndex(chat => chat.chatId === chatId);

      if(idx !== -1) {
        state.chats.splice(idx, 1);
        state.total -= 1;
      }
    },
    setTotal(state, total) {
      state.total = total;
    },
    incrementPage(state) {
      state.filter.page += 1;
    },
    setPage(state, page) {
      state.filter.page = page;
    },
    setOccupied(state, occupied) {
      state.occupied = occupied;
    },
    setFilterOccupied(state, occupied){
      state.filterOccupied = occupied;
    },
    setProjectList(state, data) {
      state.projectList = data;
    },
    setProjectOptions(state, data) {
      // 자신이 속한 프로젝트만 options에 저장
      // 추후 admin role에 대해 모든 프로젝트를 볼 수 있도록 로직 추가 예상

      const currentUser = store.getters['auth/currentUser'];

      let containsCurrentUserProjectArray = data.filter(project => {
        project.text = project.name;
        project.value = project.projectId;
        for(let projectUser of project.projectUserList) {
          if(projectUser.userId === currentUser.caller) {
            return project;
          }
        }
      });

      // console.log(containsCurrentUserProjectArray);
      state.options.projectOptions = containsCurrentUserProjectArray.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },
    setAssigneeOptions(state, data) {
      data.forEach(object => {
        object.value = object.userId;
        object.text = object.userName;
      });
      state.options.assigneeOptions = data.sort((a, b) => {
        return a.text.localeCompare( b.text);
      });
    },
    setNotifications(state, data) {
      // 23-10-10 웹소켓으로 받은 데이터를 바로 대입했더니 
      // 웹소켓 데이터 도착시기에 따라서 과거의 DB데이터가 덮어씌워지는 버그가 생김
      // 기존 가지고 있던 데이터와 받은 데이터를 합친 후 중복을 제거하는 방법으로 변경
      // state.notifications = data;

      // 배열 합치기
      let mergedNotificationsArr = [...state.notifications, ...data];

      // Set으로 변경하여 중복제거
      let uniqueNotificationsSet = new Set(mergedNotificationsArr);

      // 사용하기 쉽게 Set을 다시 배열로 변경
      state.notifications = [...uniqueNotificationsSet];
    },
    removeNotifications(state, data) {
      let index = state.notifications.indexOf(data);

      // 알림에 존재하면 삭제
      if(index != -1) {
        state.notifications.splice(index, 1);
      }
    },
    setAllProjectInfo(state, data) {
      state.allProjectInfo = data;
    },
    setAllProjectRoles(state, data) {
      state.allProjectRoles = data;
    },
    setUpdated(state, data) {
      state.filter.updated = data;
    },
    setQueryId(state,data){
      state.filter.queryId=data;
    },
    setQueryTitle(state,data){
      state.filter.queryTitle=data;
    },
    setQuery(state, data) {
      state.filter.query = data;
    },
    setQueryOrderBy(state, data) {
      state.filter.queryOrderBy = data;
    },
    setSort(state, columns) {
      state.filter.sort = columns
        .filter(col => col.sort)
        .map(col => ({
          colName: col.colName,
          sort: col.sort
        }))
    },
    resetFilter(state) {
      state.filter = {
        projectId: "",
        status: "",
        keyword: "",
        sort: [],
        page: 1,
        pageSize: 10,
      };
    },
    setStatusBarProject(state,data){
      state.statusBar.projectName = data;
    },
    setStatusBarStatus(state,data){
      state.statusBar.status = data;
    },
    setAllMethodologyOptions(state,data){
      state.options.allMethodologyOptions = data;
    },
    resetStatusBar(state) {
      state.statusBar={
        projectName:"",
        status:""
      }
    },
    setFilterProjectId(state, data){
      state.filter.projectId=data;
    },
    resetQuery(state){
      state.filter.queryId=null;
      state.filter.queryTitle="";
      state.filter.query="";
      state.filter.queryOrderBy="";
    },
    setToggleFilterSearchDetail(state,data){
      state.pageInfo.toggle.filterSearchDetail=data;
    },
    setToggleFilterProjects(state,data){
      state.pageInfo.toggle.filterProjects=data;
    },
    setToggleFilterInfo(state,data){
      state.pageInfo.toggle.filterInfo=data;
    },
    setFiles(state, data) {
      state.files = data;
    }
  },
};   